var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component } from 'vue-property-decorator';
import ShoppingManageService from '../../api/ShoppingManageService';
import { Loading } from "element-ui";
var MiniProgramSettings = (function (_super) {
    __extends(MiniProgramSettings, _super);
    function MiniProgramSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            is_open_wechat_logistics: 0,
            logistics_type: 2,
            delivery_time_type: 1,
            supplier_id: null,
        };
        _this.miniappConfig = {};
        _this.releaseStatus = {
            0: '未提交',
            1: '待发布',
            2: '已发布',
            3: '已提交',
            4: '审核中',
            5: '审核失败',
            6: '已下线',
        };
        _this.un_submit = 0;
        _this.un_release = 1;
        _this.releaseed = 2;
        _this.submited = 3;
        _this.auditing = 4;
        _this.audit_failed = 5;
        _this.downline = 6;
        return _this;
    }
    MiniProgramSettings.prototype.created = function () {
        this.service = ShoppingManageService.getInstance();
    };
    MiniProgramSettings.prototype.mounted = function () {
        this.getDetail();
    };
    MiniProgramSettings.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.configShow({}).then(function (res) {
            loadingInstance.close();
            var data = res.data.data.shopping_mp || {
                is_open_wechat_logistics: 0,
                logistics_type: 2,
                delivery_time_type: 1,
            };
            _this.miniappConfig = res.data.data.miniapp_config || {
                is_authorize: 0,
                is_release: 0,
                is_new_version: 0,
                reason: '',
                exp_qrcode: '',
            };
            if (_this.miniappConfig.is_release == _this.releaseed) {
                _this.miniappConfig.is_release_color = '#4cd964';
            }
            else if (_this.miniappConfig.is_release == _this.auditing) {
                _this.miniappConfig.is_release_color = '#ffb54d';
            }
            else {
                _this.miniappConfig.is_release_color = '#f00';
            }
            _this.formData = {
                is_open_wechat_logistics: data.is_open_wechat_logistics ? data.is_open_wechat_logistics : 0,
                logistics_type: data.logistics_type ? data.logistics_type : 2,
                delivery_time_type: data.delivery_time_type ? data.delivery_time_type : 1,
                supplier_id: res.data.data.supplier_id ? res.data.data.supplier_id : null,
            };
            if (_this.miniappConfig.is_authorize == 1 && _this.miniappConfig.is_release > 0) {
                _this.$nextTick(function () {
                    _this.service.getMiniappExpQrcode({
                        supplier_id: res.data.data.supplier_id ? res.data.data.supplier_id : null
                    }).then(function (res) {
                        _this.miniappConfig.exp_qrcode = res.data.data;
                    });
                });
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    MiniProgramSettings.prototype.save = function () {
        var _this = this;
        var params = {
            shopping_mp: this.formData,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.updateMpConfig(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            _this.getDetail();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    MiniProgramSettings.prototype.applyAuth = function () {
        var _this = this;
        this.service.getMiniappAuthUrl({}).then(function (res) {
            window.open(res.data.data.url);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    MiniProgramSettings.prototype.applyDownline = function () {
        var _this = this;
        this.$confirm('撤销下线后小程序将不可访问，确定要撤销下线吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.service.setMiniappDownline({
                supplier_id: _this.formData.supplier_id
            }).then(function (res) {
                _this.$message.success('下线成功');
                _this.miniappConfig.is_release = _this.downline;
                _this.miniappConfig.is_release_color = '#f00';
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        });
    };
    MiniProgramSettings.prototype.applyPublish = function () {
        return __awaiter(this, void 0, void 0, function () {
            var versionInfo, releaseResult, category, cates, privacySetting, privacySettingResult, commitResult, submitResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(this.miniappConfig);
                        if (this.miniappConfig.is_authorize === 0) {
                            this.$message.error('小程序未授权');
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        return [4, this.service.getMiniappVersionInfo({
                                supplier_id: this.formData.supplier_id
                            })];
                    case 2:
                        versionInfo = _a.sent();
                        this.miniappConfig.is_new_version = versionInfo.data.data.is_new_version;
                        this.miniappConfig.is_release = versionInfo.data.data.is_release;
                        this.miniappConfig.reason = versionInfo.data.data.reason;
                        if (!(versionInfo.data.data.is_release === this.releaseed && this.miniappConfig.is_new_version === 0)) return [3, 3];
                        this.$message.success('小程序已发布');
                        return [2];
                    case 3:
                        if (!(versionInfo.data.data.is_release === this.auditing)) return [3, 4];
                        this.$message.error('小程序当前版本审核中');
                        return [2];
                    case 4:
                        if (!(versionInfo.data.data.is_release === this.un_release)) return [3, 6];
                        return [4, this.service.setMiniappRelease({
                                supplier_id: this.formData.supplier_id
                            })];
                    case 5:
                        releaseResult = _a.sent();
                        console.log(releaseResult);
                        this.$message.success('发布成功');
                        return [2];
                    case 6: return [4, this.service.getMiniappCategory({
                            supplier_id: this.formData.supplier_id
                        })];
                    case 7:
                        category = _a.sent();
                        console.log(category);
                        cates = category.data.data;
                        if (category.data.is_set == 0) {
                            this.$message.error('小程序类目信息未设置,请先到小程序后台设置类目');
                            return [2];
                        }
                        return [4, this.service.getMiniappPrivacySetting({
                                supplier_id: this.formData.supplier_id
                            })];
                    case 8:
                        privacySetting = _a.sent();
                        console.log(privacySetting);
                        return [4, this.service.setMiniappPrivacySetting({
                                supplier_id: this.formData.supplier_id
                            })];
                    case 9:
                        privacySettingResult = _a.sent();
                        console.log(privacySettingResult);
                        return [4, this.service.setMiniappCommit({
                                supplier_id: this.formData.supplier_id
                            })];
                    case 10:
                        commitResult = _a.sent();
                        console.log(commitResult);
                        return [4, this.service.setMiniappSubmit({
                                supplier_id: this.formData.supplier_id,
                                category: cates,
                            })];
                    case 11:
                        submitResult = _a.sent();
                        console.log(submitResult);
                        this.$message.success('提交成功');
                        return [3, 13];
                    case 12:
                        error_1 = _a.sent();
                        this.$message.error('操作失败：' + (error_1.message || '服务器错误，请稍后重试'));
                        return [3, 13];
                    case 13: return [2];
                }
            });
        });
    };
    MiniProgramSettings = __decorate([
        Component({})
    ], MiniProgramSettings);
    return MiniProgramSettings;
}(Vue));
export default MiniProgramSettings;
